export default "__VITE_ASSET__D356_B09__"